import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { IBookmarkRequest } from '@/Module/Workspace/Model/ApiModel';
import type { IBookmark } from '@/Module/Workspace/Model/DataModel';
import { WorkspaceService } from '@/Module/Workspace/Service';

export const getBookmarkListAction = createAsyncThunk<
  IGatewayResponse<IBookmark[]>,
  Pick<IBookmarkRequest, 'PageSize' | 'PageNo'>
>('workspace/getBookmarkListAction', async (query, { signal, rejectWithValue }) => {
  return WorkspaceService.getBookMark({ ...query, BookmarkType: 1 }, signal)
    .then(({ data }) => data)
    .catch(rejectWithValue);
});
